import { ArrowUpIcon } from '@heroicons/react/24/outline';
import { IUserModel, ImageGenerationMode, Resolution } from '@packages/global';
import { useTranslation } from 'react-i18next';
import ModelSelector from '../ModelSelector';
import ImageModeSelector from '../ImageModeSelector';
import { CoinPriceDisplay } from '../../../../common/form';

interface ImageToolbarSectionProps {
  models: IUserModel[];
  modelId: string;
  mode: ImageGenerationMode;
  showModeSelector: boolean;
  isDisabled: boolean;
  modelsLoading: boolean;
  hasPrompt: boolean;
  resolution?: Resolution;
  onModelChange: (modelId: string) => void;
  onModeChange: (mode: ImageGenerationMode) => void;
  onSubmit: () => void;
}

export default function ImageToolbarSection({
  models,
  modelId,
  mode,
  showModeSelector,
  isDisabled,
  modelsLoading,
  hasPrompt,
  resolution,
  onModelChange,
  onModeChange,
  onSubmit
}: ImageToolbarSectionProps) {
  const { t } = useTranslation('editor');

  return (
    <div className="px-4 py-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {showModeSelector && (
            <ImageModeSelector
              value={mode}
              onChange={onModeChange}
              disabled={isDisabled}
            />
          )}

          <ModelSelector
            models={models}
            value={modelId}
            onChange={onModelChange}
            disabled={isDisabled}
            loading={modelsLoading}
          />

          {models.length === 0 && (
            <span className="text-xs text-orange-400">{t('imageGenForm.imageCountExceedsModel')}</span>
          )}
        </div>

        <div className="flex items-center gap-3">
          <CoinPriceDisplay modelId={modelId} resolution={resolution} />

          <button
            onClick={onSubmit}
            disabled={isDisabled || !hasPrompt || !modelId}
            className={`p-2 rounded-full transition-colors ${isDisabled || !hasPrompt || !modelId
              ? 'bg-gray-700 text-gray-500 cursor-not-allowed'
              : 'bg-gray-600 hover:bg-gray-500 text-white'
              }`}
          >
            {isDisabled ? (
              <div className="h-5 w-5 border-2 border-gray-500 border-t-white rounded-full animate-spin" />
            ) : (
              <ArrowUpIcon className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
    </div>
  );
}
